<label for="{{id}}" *ngIf="label" class="cm-upload-button-label">
    {{label}}
</label>
<label for="{{id}}"
       (click)="fileInput.click()"
       class="cm-upload-button-box mb-3"
       cmDragAndDrop="drag-over"
       (filesChangeEmiter)="onFilesChange($event)">
    <i class="fas fa-upload"></i>
    <span>{{ singleFileUpload ? "Drop file or browse" : "Drop multiple files or browse" }}</span>
</label>

<p class="text-danger mb-3" *ngFor="let fileName of duplicateFileNames">
    <i class="fa fa-info-circle mr-2" aria-hidden="true" matTooltip="{{fileName}}"></i>
File with that name already exist!
</p>

<mat-chip-list class="mat-chip-list-stacked">
    <mat-basic-chip *ngFor="let file of files">
        <span class="filelist-file-name">{{file.name}}</span>
        <span (click)="removeFile(file)" class="remove-btn">X</span>
    </mat-basic-chip>
</mat-chip-list>

<span style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height:0px;border:none;margin:0; padding:0">
<input type="file"
     #fileInput
     (click)="fileInput.value=null"
     [multiple]="!singleFileUpload"
     [id]="id+'1'"
     (change)="onFilesChange($event.target.files)">
</span>